import { apiInstance } from '@/api/api.js'
import { base64ToArrayBuffer } from '../../helpers/decodingToBase64'

const api = apiInstance()

export default {
  async generateReport({ commit, dispatch }, { companies }) {
    try {
      commit('setGenerateReportLoading', true)

      // Request with responseType blob for stream data
      const response = await api.post(
        '/reports/generate',
        {
          companies,
        },
        {
          responseType: 'blob', // This handles stream data directly
        },
      )

      // Handle stream response
      if (response.data) {
        let blob

        // Check if response is already a blob (stream data)
        if (response.data instanceof Blob) {
          blob = response.data
        } else if (typeof response.data === 'string') {
          // Fallback: if still base64 string
          try {
            const arrayBuffer = base64ToArrayBuffer(response.data)
            blob = new Blob([arrayBuffer], {
              type:
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
          } catch (decodeError) {
            // Last fallback: direct blob creation
            blob = new Blob([response.data], {
              type:
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
          }
        } else {
          // Handle other response formats (ArrayBuffer, etc.)
          blob = new Blob([response.data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
        }

        // Open in browser instead of downloading
        const url = URL.createObjectURL(blob)

        // Open in new tab/window - browser will handle Excel files
        const newWindow = window.open(url, '_blank')

        // Fallback: if popup blocked
        if (!newWindow) {
          // Alternative: create download link as fallback
          const link = document.createElement('a')
          link.href = url
          const currentDate = new Date().toISOString().split('T')[0]
          link.download = `report-${currentDate}.xlsx`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }

        // Cleanup URL after a delay
        setTimeout(() => {
          URL.revokeObjectURL(url)
        }, 2000)
      }

      commit('setGenerateReportLoading', false)
      commit(
        'appStates/setSnackbarNotification',
        'Report downloaded successfully!',
        {
          root: true,
        },
      )
      return response
    } catch (error) {
      dispatch('appStates/setErrorMessage', error, { root: true })
      commit('setGenerateReportLoading', false)
      return error
    }
  },
}
